export default __webpack_public_path__ + "img/passSetting.ba6a42e7ec73814cfabd595d0746b0ec.png";